const DAY_MS = 24 * 60 * 60 * 1000;
const MIN_AGE_DAYS = 21;
const MIN_STEPS_WITH_AGE = 3;
const MIN_STEPS_ALONE = 8;

export interface GraduationSignals {
  journeySuggestedReason?: string | null;
  createdAt?: string | null;
  stepsCompleted: number;
  now: number;
}

/** Spec §3.b.6 — the invitation appears only once a project has earned it:
 *  the seeder flagged it, or it has both age (3+ weeks) and motion (3+ steps
 *  done), or the motion alone is unmistakable (8+ steps). */
export function graduationReady(s: GraduationSignals): boolean {
  if (s.journeySuggestedReason && s.journeySuggestedReason.trim()) return true;
  const created = s.createdAt ? new Date(s.createdAt).getTime() : NaN;
  const ageDays = Number.isFinite(created) ? (s.now - created) / DAY_MS : 0;
  if (ageDays >= MIN_AGE_DAYS && s.stepsCompleted >= MIN_STEPS_WITH_AGE) return true;
  return s.stepsCompleted >= MIN_STEPS_ALONE;
}

export const GRADUATE_HINT_KEY = "cockpit_graduate_hint_seen";

type StorageLike = { getItem: (k: string) => string | null; setItem: (k: string, v: string) => void };

export function readGraduateHintSeen(storage: StorageLike): boolean {
  try {
    return storage.getItem(GRADUATE_HINT_KEY) === "1";
  } catch {
    return false;
  }
}

export function markGraduateHintSeen(storage: StorageLike): void {
  try {
    storage.setItem(GRADUATE_HINT_KEY, "1");
  } catch {
    /* private mode / blocked storage — the hint just shows again next time */
  }
}
